// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".course-context[data-v-0b9eea13] {\n  background: #eef6f5;\n  border: 1px solid #b9e3de;\n  border-radius: 4px;\n  padding: 9px 12px;\n  font-size: 13px;\n  color: #0a7d74;\n  margin-bottom: 18px;\n}\n.course-context strong[data-v-0b9eea13] {\n    color: #087a71;\n}\n.note[data-v-0b9eea13] {\n  margin-top: 16px;\n  font-size: 13px;\n  color: #6b7b8c;\n}\n", ""]);
// Exports
module.exports = exports;
